import { StepIconProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  error: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(156, 5, 0) 0%, rgb(140, 11, 11), rgb(140, 11, 11) 100%)!important',
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(119, 105, 161) 0%, rgb(111, 92, 136) 50%, rgb(78, 60, 77) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(15, 176, 0) 0%, rgb(13, 169, 10) 50%, rgb(37, 138, 35) 100%)',
  },
});

type StepItemProps = StepIconProps & { iconElement: React.ReactElement };
export const StepIcon = (props: StepItemProps) => {
  const classes = useColorlibStepIconStyles();
  const { active, completed, error, iconElement } = props;
  return (
    <div
      className={clsx(classes.root, {
        [classes.error]: error,
        [classes.active]: active && !error,
        [classes.completed]: completed && !error,
      })}
    >
      {iconElement}
    </div>
  );
};
